import moment from 'moment';

(() => {
  class PromoDetailController {
    constructor($q, $state, $stateParams, ngDialog, toastr, Notifications, Promos, Utils) {
      'ngInject';

      Object.assign(this, {
        $q,
        $state,
        $stateParams,
        ngDialog,
        toastr,
        Notifications,
        Promos,
        Utils,
        minExpiration: moment().add(1, 'day').toDate(),
        emailLimit: 1,
        pagination: {
          limit: 10
        },
        usesChartOptions: {
          segmentShowStroke: false,
          percentageInnerCutout: 80 // animateRotate: false

        },
        MAX_USES: 5000,
        MIN_DATE: new Date()
      });
      this.loading = true;
      this.Promos.fetch(this.$stateParams.id).then(({
        data: promo
      }) => {
        this.promo = new Promo(promo);
        this.originalPromo = angular.copy(this.promo);

        if (this.promo.hasCodes) {
          this.getSingleUseCodes();
        }
      }).finally(() => {
        this.loading = false;
      });
    }

    cancel() {
      if (this.hasChanged()) {
        const config = {
          template: 'app/components/modals/confirm.tpl.html',
          data: {
            title: 'Unsaved Changes',
            content: 'You have unsaved changes. Are you sure you want to cancel?'
          }
        };
        this.ngDialog.openConfirm(config).then(() => this.$state.go('promos'));
      } else {
        this.$state.go('promos');
      }
    }

    closeOrDelete() {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: `${this.promo.started ? 'Close' : 'Delete'} Promotion`,
          content: 'Are you sure you want to do this? This action is irreversible.'
        }
      };
      this.ngDialog.openConfirm(config).then(() => this.Promos.delete(this.promo.id)).then(() => this.$state.go('promos'));
    }

    exportCodesToCSV() {
      if (!this.promo.singleUse) {
        return;
      }

      this.Promos.exportCodesToCSV(this.promo.id, this.promo.name);
    }

    getSingleUseCodes() {
      this.Promos.getSingleUseCodes(this.promo.id, this.pagination).then(({
        data: codes
      }) => {
        Object.assign(this.pagination, codes.pagination);
        this.codes = codes.data;
      });
    }

    hasChanged() {
      return !angular.equals(this.originalPromo, this.promo);
    }

    openUpdateDialog() {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: 'Update Promotion',
          content: 'Are you sure you want to do update this promotion?'
        }
      };
      this.ngDialog.openConfirm(config).then(this.verifyUpdate.bind(this));
    }

    verifyUpdate() {
      const {
        max_uses: newMaxUses
      } = this.promo;
      const {
        max_uses: oldMaxUses
      } = this.originalPromo;
      const changes = this.Utils.findDifference(this.originalPromo, this.promo);

      if (this.promo.started || this.promo.singleUse) {
        // can't decrease max uses once promo has started or if campaign is singleUse
        if (changes.max_uses && changes.max_uses < oldMaxUses) {
          this.promo.max_uses = this.originalPromo.max_uses;
          this.toastr.error(this.promo.singleUse && !this.promo.started ? this.Notifications.promos.decreaseUsesSingleUse : this.Notifications.promos.decreaseUsesAfterStart);
          return;
        }
      } // check some stuff if campaign is SPECIFICALLY single use


      if (this.promo.singleUse) {
        // check to see if we've changed max uses to a greater value
        if (newMaxUses !== oldMaxUses && newMaxUses > oldMaxUses) {
          // if we have, generate codes with the difference
          const usesDiff = parseInt(newMaxUses) - parseInt(oldMaxUses);
          this.checkMaxUses(usesDiff).then(() => {
            this.Promos.generateSingleUseCodes(this.promo.id, usesDiff).then(() => {
              // we can't update single_use max uses so blow that key UP
              delete changes.max_uses;
              this.promo.max_uses = newMaxUses;
              this.updatePromotion(changes);
            }).then(() => {
              this.getSingleUseCodes();
              this.toastr.success(this.Notifications.promos.updateSuccess);
            });
          });
        } else {
          this.updatePromotion(changes);
        }
      } else {
        this.updatePromotion(changes);
      }
    }

    updatePromotion(changes) {
      if (_.isEmpty(changes)) {
        return;
      }

      if (changes.hasOwnProperty('max_uses') && (!changes.max_uses || changes.max_uses.length === 0)) {
        changes.max_uses = null;
      }

      this.Promos.update(this.promo.id, changes).then(() => {
        this.originalPromo = angular.copy(this.promo);
        this.toastr.success(this.Notifications.promos.updateSuccess);
      }).catch(() => this.toastr.error(this.Notifications.generic.failure));
    }

    checkMaxUses(uses) {
      if (uses > this.MAX_USES) {
        const dialogConfig = {
          template: 'app/components/modals/confirm.tpl.html',
          showClose: false,
          data: {
            title: 'Are you sure?',
            content: `You\'re creating a campaign with over ${this.MAX_USES} promotion codes. Are you sure you want to do this?`,
            buttons: {
              cancel: 'Cancel',
              confirm: 'Yes'
            }
          }
        };
        return this.ngDialog.openConfirm(dialogConfig);
      }

      return this.$q.resolve();
    }

  }

  PromoDetailController.$inject = ["$q", "$state", "$stateParams", "ngDialog", "toastr", "Notifications", "Promos", "Utils"];
  angular.module('pims').controller('PromoDetailController', PromoDetailController);
})();